import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {observer} from "mobx-react";
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import DateTimeInput from "./DateTimeInput";
import DepartureOptionInput from "./DepartureOptionInput";
import {DepartureOptionTextarea} from "./DepartureOptionTextarea";
import moment, {isMoment} from "moment";

export const DepartureOption = observer((props) => {
    const [state, setState] = useState(props.form || {})

    const changeDateTime = (key, value) => {
        setState(prev => ({...prev, [key]: value}))
    }
    const changeHandler = event => {
        setState(prev => ({...prev, [event.target.id]: event.target.value}))
        saveHandler()
    }
    const headerHandler = () => {
        const startDate = moment(state.start_date ).format('DD.MM.YYYY HH:mm')
        const endDate = moment(state.end_date ).format('DD.MM.YYYY HH:mm')


        return (
            <span className={"clipText"}>
                Выезд
                {startDate !== "Invalid date" && <> с <span style={{color: '#009ff5'}}>{startDate}</span></>}
                {endDate !== 'Invalid date' && <> по <span style={{color: '#009ff5'}}>{endDate}</span>. </>}
                {state.address && <>По адресу: <span title={state.address}
                                                     style={{color: '#009ff5'}}>{state.address}</span></>}
            </span>)
    }

    useEffect(()=> {
        saveHandler(state)
    }, [state])

    const saveHandler = () => {
        props.save(state)
    }
    return (
        <Styled key={props.id  || state.startDate } isOpen={props.isOpen} className={props.className}>
            <div onClick={props.open} className="header">
                <div className="title"> {headerHandler()} </div>
                <Arrow isOpen={props.isOpen} className="fas fa-chevron-down"/></div>
            <div className="content">
                <div className="dates">
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DateTimeInput className={'dateInput'} value={state.start_date || state.startDate}
                                       onChange={date => changeDateTime("start_date", date)}
                                       label={"Дата начала"}/>
                        <DateTimeInput className={'dateInput'} value={state.end_date || state.endDate}
                                       onChange={date => changeDateTime("end_date", date)}
                                       label={"Дата конца"}/>
                    </MuiPickersUtilsProvider>
                </div>
                <br/>

                <DepartureOptionInput id={"address"} value={state.address} onChange={changeHandler} label={"Адрес"}/>
                <br/>
                <DepartureOptionTextarea id={"comment"} value={state.comment} onChange={changeHandler}
                                         label={"Комментарий"}/>
                <br/>
                <div className="buttonArea">
                    <button onClick={_ => props.deleteDeparture(state)} className="delete">Удалить</button>
                </div>
            </div>
        </Styled>
    )
})


const Styled = styled.div`
  transition: 500ms;
  background: #FAFAFA;
  height: 500px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  max-height: ${p => p.isOpen ? "550px" : "40px"};
  width: 100%;
  border-radius: 5px;
  padding: 0 20px;
  overflow: hidden;

  .header {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px;
    cursor: pointer;
    text-wrap: none;
    width: 100% !important;

    .title {
      width: 95%;
    }
  }

  .clipText {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }

  .dates {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .dateInput {
    width: 49%;
  }

  textarea {
    resize: none;
  }

  .buttonArea {
    width: 100%;
    justify-content: flex-end;
    text-align: right;

    button {
      height: 50px;
      width: 140px;
      margin-left: 10px;
    }

    .delete {
      background: white;
      border: 2px solid red;
      color: black;
    }

  }
}

@media (max-width: 1100px) {
  height: 550px;
  max-height: ${p => p.isOpen ? "600px" : "40px"};

  .dates {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    flex-direction: column;
    width: 100%;


    .dateInput {
      width: 100%;
    }
  }
}
`
const Arrow = styled.i`
transition: 300ms;
transform: rotate(${p => p.isOpen ? 180 : 0}deg);
`

export default DepartureOption
